import { useEffect } from "react";

import CacheUtils from "../../../utils/cache-utils";
import { useLazyGetUserByTokenQuery } from "./user-api";

export const useGetUser = () => {
  const token = CacheUtils.getAccessToken();
  const [getUser, { data, error, isLoading }] = useLazyGetUserByTokenQuery();

  useEffect(() => {
    if (token) getUser({ token }, true);
  }, [token, getUser]);

  return { user: data, error, isLoading };
};
